export default {
  data() {
    return {
      navList: [
        { name: '首页', path: '/index' },
        { name: '我要脱单', path: '/luck' },
        { name: '身份认证', path: '/applyInitiation' },
        { name: '相亲大会', path: '/activity' },
        { name: '一对一红娘', path: '/huechys' },
        { name: '情感交流', path: '/emotion' },
        { name: '联系我们', path: '/about' },
      ],
      botList: [
        { name: '首页', path: '/index' },
        { name: '我要脱单', path: '/luck' },
        { name: '相亲大会', path: '/activity' },
        { name: '一对一红娘', path: '/huechys' },
        { name: '情感交流', path: '/emotion' },
        { name: '我的芒果', path: '/me' },
      ],
      i: null,
      inde: null,
      isShow: false,
      isHide: false,
      userInfo: {}, //个人信息
      relationMessage: {}, //联系我们
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        switch (val.path) {
          case '/index':
            this.inde = 0
            break
          case '/luck':
            this.inde = 1
            break
          case '/applyInitiation':
            this.inde = 2
            break
          case '/activity':
            this.inde = 3
            break
          case '/huechys':
            this.inde = 4
            break
          case '/emotion':
            this.inde = 5
            break
          case '/about':
            this.inde = 6
            break
          default:
            break
        }
        if (val.path === '/login' || val.path === '/forget' || val.path === '/myOrder') {
          this.i = 7
        } else {
          this.i = null
        }
        if (val.path === '/register' || val.path === '/forget') {
          this.isShow = false
        } else {
          if (localStorage.getItem('incredible-k')) {
            this.getUserInfo()
          }
          this.isShow = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    //跳转
    changeInde(index) {
      if (this.$route.path == this.navList[index].path) return
      this.inde = index
      if (index == 1) {
        if (this.userInfo.is_member != 1 && this.userInfo.is_member != 3) {
          this.inde = 2
          this.$router.push({ path: '/applyInitiation' })
          return
        }
      }

      this.$router.push(this.navList[index].path)
    },
    //去登陆
    goLogin() {
      this.$router.push('/login')
    },
    quit() {
      this.$router.push('/login')
      localStorage.removeItem('incredible-k')
    },
    goMe() {
      if (this.$route.path != '/me') {
        this.$router.push('/me')
      }
    },
    //获取个人信息
    getUserInfo() {
      this.$axios.post('/api/users/getUserInfo').then((res) => {
        if (res.data.code === 0) {
          this.userInfo = res.data.data
        }
      })
    },
    //获取联系我们信息
    getRelationMessage() {
      this.$axios.post('/api/index/contact_us').then((res) => {
        if (res.data.code === 0) {
          this.relationMessage = res.data.data
        }
      })
    },
  },
  created() {
    this.getRelationMessage()
    if (localStorage.getItem('incredible-k')) {
      this.getUserInfo()
    }
  },
}
